exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mr_40{\n  margin-right:0.20833rem;\n}\n", ""]);

// exports
